class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Safari fix: track when user is clicking inside the dropdown
    // Safari doesn't focus links on click, causing focusout to close the menu prematurely
    this.isClickingInside = false;
    this.content.addEventListener('mousedown', () => {
      this.isClickingInside = true;
    });
    document.addEventListener('mouseup', () => {
      this.isClickingInside = false;
    });
  }

  onFocusOut() {
    setTimeout(() => {
      // Don't close if user is clicking inside (Safari fix)
      if (this.isClickingInside) return;
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.setupMenuLinks();
  }

  setupMenuLinks() {
    // Allow links inside summary to navigate without toggling dropdown
    const menuLinks = this.querySelectorAll('.header__menu-item-link');
    menuLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        // Stop propagation to prevent the summary toggle behavior
        event.stopPropagation();

        // Only intercept unmodified primary-button clicks
        // Let modifier clicks (Cmd/Ctrl+click, middle-click, Shift+click) use browser defaults
        const isModifiedClick = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
        if (isModifiedClick) {
          return;
        }

        // Navigate manually for unmodified primary clicks
        event.preventDefault();
        if (link.href) {
          window.location.href = link.href;
        }
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
